



















import Vue from "vue";

export default Vue.extend({
  name: "BaseSearchInput",
  props: {
    value: {
      type: [Number, String],
      required: true,
    },
    hint: {
      type: String,
      default: "Search ...",
    },
    limit: {
      type: Number,
      default: null,
    },
  },
  mounted() {
    this.$refs.input.focus();
  },
  methods: {
    updateSelf(value: string) {
      let toReturn: string = value;
      /*       if (this.$props.type === "number") {
        toReturn = this.isfloat ? parseFloat(toReturn) : parseInt(toReturn);
        if (!toReturn || isNaN(<number>toReturn)) {
          toReturn = 0;
        }
        if (this.$props.min && toReturn < this.$props.min) {
          toReturn = this.$props.min;
        }
        if (this.$props.max && toReturn > this.$props.max) {
          toReturn = this.$props.max;
        }
        //Округление до двух знаков после запятой
        if (this.isfloat) {
          toReturn = Math.floor(<number>toReturn * 100) / 100;
        }
      } */
      if (this.limit !== null) {
        toReturn = toReturn.toString().slice(0, this.limit);
      }
      (<HTMLInputElement>this.$refs.input).value = toReturn.toString();
      //this.value = toReturn;
      this.$emit("input", toReturn);
    },
    onBlur() {
      this.$emit("blur");
    },
  },
});
